import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { DialogContent, DialogTitle } from '@mui/material';
import { Close } from '@mui/icons-material';
import Button from '@mui/material/Button';
import axios from 'axios';
import * as yup from 'yup';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { FormError } from '~/components/form/FormError';
import { PresetAutocomplete } from '../PresetAutocomplete';
const formSchema = yup
    .object({
    nutritionName: yup.string().required('Nutrition name is required'),
    nutritionDescription: yup.string().nullable()
})
    .required();
export const AddNutritionModal = (props) => {
    const { onRequestClose, itemToEdit, patientId, onSuccess } = props;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const methods = useForm({
        resolver: yupResolver(formSchema),
        defaultValues: {
            nutritionName: itemToEdit ? itemToEdit.nutritionName : '',
            nutritionDescription: itemToEdit ? itemToEdit.nutritionDescription : ''
        },
    });
    const { formState: { errors }, handleSubmit, register, } = methods;
    const onFormSubmit = async ({ nutritionName, nutritionDescription }) => {
        setIsSubmitting(true);
        console.log('submitting');
        const data = {
            nutritionName: nutritionName == '' ? null : nutritionName,
            nutritionDescription: nutritionDescription == '' ? null : nutritionDescription
        };
        console.log(data);
        if (itemToEdit) {
            const response = await axios.post('/api/carePlan/editNutrition', {
                nutritionId: itemToEdit.id,
                nutritionName: data.nutritionName,
                nutritionDescription: data.nutritionDescription
            });
            const new_nutrition = response.data.data.new_nutrition;
            const updatedNutrition = {
                id: new_nutrition.id,
                patientId: new_nutrition.patient_id,
                carePlanId: new_nutrition.care_plan_id,
                nutritionName: new_nutrition.nutrition_name,
                nutritionDescription: new_nutrition.nutrition_description,
                updatedAt: new Date(new_nutrition.updated_at),
                deletedAt: new Date(new_nutrition.deleted_at),
                createdAt: new Date(new_nutrition.created_at),
                isEditable: new_nutrition.is_editable,
                month: new_nutrition.month
            };
            onSuccess(updatedNutrition);
        }
        else {
            const response = await axios.post('/api/carePlan/addNutrition', {
                patientId: patientId,
                nutritionName: data.nutritionName,
                nutritionDescription: data.nutritionDescription
            });
            const new_nutrition = response.data.data.new_nutrition;
            const updatedNutrition = {
                id: new_nutrition.id,
                patientId: new_nutrition.patient_id,
                carePlanId: new_nutrition.care_plan_id,
                nutritionName: new_nutrition.nutrition_name,
                nutritionDescription: new_nutrition.nutrition_description,
                updatedAt: new Date(new_nutrition.updated_at),
                deletedAt: new Date(new_nutrition.deleted_at),
                createdAt: new Date(new_nutrition.created_at),
                isEditable: new_nutrition.is_editable,
                month: new_nutrition.month
            };
            onSuccess(updatedNutrition);
        }
        setIsSubmitting(false);
    };
    return (React.createElement(Dialog, { open: true, PaperProps: {
            sx: { maxHeight: '60vh', maxWidth: '50%', width: '50%' }
        } },
        React.createElement(DialogTitle, { sx: { m: 0, p: 2, display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between' }, id: "customized-dialog-title" },
            itemToEdit ? 'Edit Nutrition Need' : 'Add Nutrition Need',
            React.createElement("button", { style: { marginLeft: 'auto', float: 'right' }, onClick: onRequestClose },
                React.createElement(Close, null))),
        React.createElement(DialogContent, { dividers: true },
            React.createElement(FormProvider, { ...methods },
                React.createElement("form", { onSubmit: handleSubmit(onFormSubmit), noValidate: true },
                    React.createElement("div", { className: "mb-5", style: { marginLeft: 'auto', marginRight: 'auto', width: '70%' } },
                        React.createElement("div", { className: "flex justify-between items-center" },
                            React.createElement("div", { style: { width: '100%' } },
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Nutrition Need"),
                                React.createElement("div", { className: "row" },
                                    React.createElement(PresetAutocomplete, { name: "nutritionName", presets: props.presets, category: "nutrition", field: "nutrition", placeholder: "e.g., Following carb-controlled diet" })),
                                React.createElement("br", null),
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Description/Notes"),
                                React.createElement("div", { className: "row" },
                                    React.createElement("textarea", { className: 'problem-list-scroll', onKeyDown: (event) => event.stopPropagation(), style: {
                                            fontFamily: 'Barlow',
                                            verticalAlign: 'top',
                                            overflowY: 'scroll',
                                            height: '85px',
                                            padding: '10px',
                                            width: '100%',
                                            borderWidth: '1px',
                                            borderColor: '#B9B9B9',
                                            borderRadius: '4px'
                                        }, placeholder: 'Enter Notes', ...register('nutritionDescription'), defaultValue: itemToEdit?.nutritionDescription ?? '' })),
                                React.createElement(FormError, { errors: errors, name: "add-problem" })))),
                    React.createElement("div", { className: "flex justify-between items-center" },
                        React.createElement(Button, { style: { width: '100%' }, variant: "contained", disabled: isSubmitting, type: "submit", color: "primary" }, itemToEdit ? 'Edit Nutrition Need' : 'Add Nutrition Need')))))));
};
